var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloud-design-fixed"},[_c('iframe',{attrs:{"id":"cloud-design","src":_vm.url,"width":"100%","height":"100%","scrolling":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }